import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import { PropType, computed, onMounted, ref } from 'vue';
import { NEW_ID } from '@/util/constants';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { useStore } from 'vuex';
import { ContentStoreState, ContentStoreActions } from '@/stores/content.store';
import { DataResponse } from '@/services/base.service';
import { ScheduleItem } from '@/models/schedule-item.model';
import { Initiative } from '@/models/initiative.model';
import DateField from '@/components/common/DateField.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduleItemForm',
  props: {
  data: {
    type: Object as PropType<ScheduleItem>,
    required: true,
  },
},
  setup(__props) {

const events = useEvents();
const store = useStore<ShiftCMSState & { cns: ContentStoreState }>();

const initiatives = computed<Initiative[]>(() => store.state.cns.initiatives);

const props = __props;

const model = ref<ScheduleItem>({
  ...props.data,
});

const action = computed<string>(() =>
  model.value.id === NEW_ID ? 'Add' : 'Save',
);

const valid = ref<boolean>(true);

const cancel = () => {
  store.commit(Mutations.HideDrawer);
};

const saveItem = async () => {
  let res: DataResponse<ScheduleItem | null> = {
    status: false,
    data: null,
  };

  if (model.value.id === NEW_ID) {
    res = await store.dispatch(
      ContentStoreActions.CreateScheduleItem,
      model.value,
    );
  } else {
    res = await store.dispatch(
      ContentStoreActions.UpdateScheduleItem,
      model.value,
    );
  }

  if (res.status) {
    store.dispatch(Actions.ShowNotification, {
      message: `Saved Schedule`,
      type: 'success',
    });
    events.emit(Event.UpdateContentItem);
    cancel();
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: `Failed to saved Schedule`,
      type: 'error',
    });
  }
};

const removeItem = async () => {
  if (
    model.value &&
    model.value.id !== NEW_ID &&
    confirm(`Are you absolutely sure you want to delete this Schedule?`)
  ) {
    store.dispatch(ContentStoreActions.DeleteScheduleItem, model.value.id);

    store.commit(Mutations.HideDrawer);
  }
};

onMounted(() => {
  store.dispatch(ContentStoreActions.GetInitiatives);
});

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveItem, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t(action.value)) + " Scheduled Initiative", 1),
          _createVNode(_component_v_alert, { type: "info" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" A scheduled initiative will be used for "),
              _createElementVNode("i", null, "initiative of the day", -1),
              _createTextVNode(" on the date chosen. Add a description for clarity why this was chosen. ")
            ])),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "mt-8" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: model.value.description,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.description) = $event)),
                    label: "Description",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(DateField, {
                    modelValue: model.value.date,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.date) = $event)),
                    label: "Date",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_autocomplete, {
                    modelValue: model.value.initiative,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.initiative) = $event)),
                    items: initiatives.value,
                    label: "Initiative",
                    "item-text": "title",
                    "return-object": "",
                    required: ""
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { col: "2" }),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              (model.value.id !== -1)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    class: "mt-2",
                    type: "button",
                    color: "warning",
                    onClick: removeItem,
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("Delete")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "mt-2",
                type: "button",
                onClick: cancel,
                block: ""
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "mt-2",
                type: "submit",
                color: "success",
                block: ""
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("Edit")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { col: "2" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})